module.exports = __webpack_public_path__ + "img/users1.fd3401e2.svg";